<template>
  <td class="list__row">
    <span
      v-popover:transfer-operation
      :class="rowCss"
      @click="showTransferInfo"
    >
      {{ record.operation_name }}
    </span>
  </td>
</template>

<script>
import { stockMovement } from '@/stock/constants/stockMovement';
export default {
  emits: ['on-show-transfer'],
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rowCss() {
      const { operation_name } = this.record;
      if (operation_name === 'передача') {
        return ['row__pseudolink_blue'];
      }
    },
  },
  methods: {
    showTransferInfo() {
      if (this.record.operation_name !== 'передача') {
        return;
      }
      let transferrerKey = 'transferrer_provider_id';
      if (this.record.transferrer_user_id !== null) {
        transferrerKey = 'transferrer_user_id';
      }
      const value =  stockMovement.transferrerDiffs[transferrerKey];
      const from = this.record[transferrerKey][value.field];
      const to = this.record.current_user_id.login;
      const info = [
        `От кого: ${value.type} "${from}"`,
        `Кому: сотруднику "${to}"`,
      ];
      this.$emit('on-show-transfer', info);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/features/stock-movement/OperationNameRow.vue